import React, {useEffect, useRef, useState} from 'react';
import MessageList from './MessagesList';
import InputField from './InputField';
import styles from './ChatBotComponent.module.css';
import {Button} from '@mui/material';
import {
  deleteRecentQueries,
  getChatHistory,
  getlatestSummary,
  saveChatHistory,
} from '../../Services/chat-bot-service';
import {
  CONTENT_REGEX_TWO,
  CONTENT_REGEX,
  apiBaseURL,
  TOPLINE_AUTO_SUGGESTIONS_WHAT,
  restrictedUsers,
  variationData,
  // TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT,
} from '../../Common/Constants';
import {callLogEvent, getSeconds} from '../../Common/Util';
import {useOktaAuth} from '@okta/okta-react';
import Layout from '../../Common/Components/Layout/Layout';
import TabTitle from '../../Common/Components/TabTitle/TabTitle';
import DashboardListInChat from '../../Common/Components/DashboardListInChat/DashboardListInChat';
import {Col, Row, Spinner} from 'react-bootstrap';
import DOMPurify from 'dompurify';
import axios from 'axios';
import PBIDashboard from '../../Common/Components/PBIDashboard/PBIDashboard';
import {v4 as uuidv4} from 'uuid';
import CloseIcon from '@mui/icons-material/Close';
import ChatRender from './ChatRender';
import {useDispatch} from 'react-redux';
import {updateSummary, updateTitle} from '../../Store/chatBotSlice';
import {useAppSelector} from '../../Store/Store';
import {
  isMiddleEastMarket,
  MIDDLE_EAST_DATA_SOURCE,
} from "../../Common/httpClient";
interface ChatBotComponentProps {
  onSourceSelect: (sourceName: string, action?: string) => void;
  handleDashboardClick: (projName: string, url: string) => void;
  isPanelOpen: boolean;
  togglePanel: () => void;
}

const ChatBotComponent = ({
  onSourceSelect,
  isPanelOpen,
  togglePanel,
}: ChatBotComponentProps) => {
  const [pageTitle, setPageTitle] = useState('');
  const [dashboardURL, setDashboardURL] = useState('');
  const [messages, setMessages] = useState<any>([]);
  const [chatHistory, setChatHistory] = useState<any>([]);
  const {authState} = useOktaAuth();

  const switchSuggestion: any = (pageTitle: string) => {
    switch (pageTitle) {
      // case 'UAE MT':
      //   return TOPLINE_AUTO_SUGGESTIONS_WHAT_UAE_MT;
      default:
        return TOPLINE_AUTO_SUGGESTIONS_WHAT;
    }
  };
  const [latestSuggestions, setLatestSuggestions] = useState(
    switchSuggestion(pageTitle)
  );
  const [isMessageSent, setIsMessageSent] = useState(false);
  const [threadId1, setThreadId1] = useState<any>('');
  const [threadId2, setThreadId2] = useState<any>('');
  const [sessionContext, setSessionContext] = useState<any>([]);
  const [queryAnalyser, setQueryAnalyser] = useState<any>([]);
  const [isIdeal, setIsIdeal] = useState(true);
  const stateRef = useRef();
  const [currentDataSource, setCurrentDataSource] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');
  const [cancelTokenSource, setCancelTokenSource] = useState<any>();
  const [showDashboard, setShowDashboard] = useState<boolean>(false);
  const [requestId, setRequestId] = useState<string>('');
  const currentUserEmail = sessionStorage.getItem('emailid')?.toLowerCase();
  const [attachmentId, setAttachmentId] = useState<string>('');
  const [isLoading, setLoading] = useState<boolean>(false);
  // const [isPanelOpen, setIsPanelOpen] = useState(false);

  const [loadingMessage, setLoadingMessage] = useState('');
  const [displayMessage, setDisplayMessage] = useState('');
  const [counter, setCounter] = useState(0);

  const [getVariation, setVariation] = useState(['']);
  //suffle function
  const shuffleArray = (array: any[]) => {
    let currentIndex = array.length,
      randomIndex;
    // While there remain elements to shuffle.
    while (currentIndex !== 0) {
      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
        array[randomIndex],
        array[currentIndex],
      ];
    }
    return array;
  };
  const handlePlaceHolderMessage = () => {
    var random: number = Math.floor(Math.random() * 4) + 1;
    setVariation(variationData['Variation ' + random]);
    setLoadingMessage(
      variationData['Variation ' + random][counter % getVariation.length]
    );
    setCounter((prevCounter) => (prevCounter + 1) % getVariation.length);
  };
  useEffect(() => {
    let timeOut = loadingMessage.length * 110 + 1000;
    if (!isIdeal) {
      const interval = setInterval(() => {
        setLoadingMessage(getVariation[counter % getVariation.length]);
        setCounter((prevCounter) => (prevCounter + 1) % getVariation.length);
      }, timeOut);
      return () => clearInterval(interval);
    } else {
      setLoadingMessage('');
      setCounter(0);
      timeOut = 5000;
    }
  }, [isIdeal, counter, getVariation, loadingMessage]);

  useEffect(() => {
    let index = 1;
    if (!isIdeal && loadingMessage !== '') {
      const interval1 = setInterval(() => {
        if (index < loadingMessage.length) {
          setDisplayMessage(loadingMessage.substring(0, index));
          index++;
        }
      }, 100);

      return () => clearInterval(interval1);
    } else {
      setDisplayMessage('');
      index = 1;
    }
  }, [isIdeal, loadingMessage]);

  useEffect(() => {
    if (localStorage.getItem('DataSource') === null) {
      localStorage.setItem('DataSource', 'topline');
      setCurrentDataSource('topline');
    } else {
      setCurrentDataSource(localStorage.getItem('DataSource')!);
    }
  }, []);

  interface summaryProps {
    projName: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
    param6?: string;
    param7?: string;
    param8?: string;
    time_dimension?: string;
  }
  let dispatch = useDispatch();
  let chatList = useAppSelector((state) => state.chatBotDetails.summaryInfo);

  const [disableSummaryBtn, setDisableSummaryBtn] = useState(false);

  const getSummary = async (payload: summaryProps) => {
    const updatedSuggesstions = switchSuggestion(payload.projName);
    setLatestSuggestions(updatedSuggesstions);
    setDisableSummaryBtn(true);
    const startTime = Date.now();
    const reqId = uuidv4();
    const response = await getlatestSummary(payload);
    // const response = payload.projName.trim()=="FLNA Topline"?await getlatestSummary(payload):uaeResponse2;
    if (response && response.summary && response?.summary['business_analyst']) {
      const endTime = Date.now();
      const summaryInfo = response?.summary['business_analyst'];
      const responses: any = [];
      saveChatHistory({
        question: 'Generate Summary',
        answer: summaryInfo,
        email: currentUserEmail,
        images: JSON.stringify([]),
        agent_metadata: JSON.stringify([]),
        response_time_in_seconds: getSeconds(startTime, endTime),
        request_id: reqId,
      });

      let imgArr: any = response.summary.images;
      responses.push(
        // { sender: 123, chatMessage: "Generate Summary", images: [] },
        {
          chatId: reqId,
          request_id: reqId,
          sender: 'summary',
          chatMessage: summaryInfo,
          images: Array.isArray(imgArr) && imgArr?.length > 0 ? imgArr : [],
          content: '',
          suggestions: updatedSuggesstions,
          is_liked: false,
          is_disliked: false,
          is_saved: false,
          response_time_in_seconds: getSeconds(startTime, endTime),
          isError: false,
        }
      );
      // setMessages(responses);
      setMessages([...messages, ...responses]);
      localStorage.setItem(
        'lastChatHistory',
        JSON.stringify([...messages, ...responses])
      );
      dispatch(updateSummary(JSON.stringify([...messages, ...responses])));
      setDisableSummaryBtn(false);
    }
  };

  useEffect(() => {
    if (messages.length === 0 && chatList && JSON.parse(chatList!).length > 0) {
      const lastChatHistory = JSON.parse(chatList!);
      const responses: any = [];
      lastChatHistory!.forEach((item: any) => {
        responses.push({
          chatId: item.chatId,
          request_id: item.request_id,
          sender: item.sender,
          chatMessage:
            item.sender === 123 || item.sender === 'summary'
              ? item.chatMessage
              : genereateGridRow(item.content),
          images:
            Array.isArray(item.images) && item.images.length > 0
              ? getImageBox(item.images)
              : [],
          content: item.content,
          question: item.question,
          suggestions: item.suggestions,
          is_liked: item.is_liked,
          is_disliked: item.is_disliked,
          response_time_in_seconds: item.response_time_in_seconds,
          is_saved: item.is_saved,
          agent_metadata: item['agent_metadata'],
          isError: item.isError,
          hash: item?.hash ? item?.hash : '',
        });
      });
      setMessages(responses);
      stateRef.current = responses;
    } else {
      handleMessages(messages);
    }
  }, [messages]);
  const removeFirstElement = (element: any, index: number) => {
    return index > 0;
  };
  const getChatResp = async (question: any, oldMessages: any) => {
    const startTime = Date.now();
    const reqId = uuidv4();
    setRequestId(reqId);
    let data = authState?.idToken?.claims;
    const payload = {
      request_id: reqId,
      old_dialog: true,
      message: question,
      threadID1: threadId1,
      threadID2: threadId2,
      persona_name: 'leadership',
      project_name: currentDataSource,
      email: currentUserEmail,
      docfile_id: attachmentId,
      username: data?.name,
      context:
        sessionContext.length > 5
          ? sessionContext.filter(removeFirstElement)
          : sessionContext,
      query_analyser:
        queryAnalyser.length > 5
          ? queryAnalyser.filter(removeFirstElement)
          : queryAnalyser,
    };
    const source: any = axios.CancelToken.source();
    // Create a cancel token
    setCancelTokenSource(source);
    const lastChatHistory = [...oldMessages];
    const responses: any = [];
    //URL Changing based on the project name
    let url = apiBaseURL;
    await axios
      .post(url + '/api/chat', payload, {
        cancelToken: source.token,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')!}`,
        },
      })
      .then((res: any) => {
        const response = res?.data;
        const endTime = Date.now();
        setThreadId1(response?.threadID1);
        setThreadId2(response?.threadID2);

        if (response?.success) {
          let QueryAnalyser = '';
          response?.responses?.forEach((item: any, itemIndex: number) => {
            if (item['Query Analyser'] && item['Query Analyser'] !== '') {
              QueryAnalyser = item['Query Analyser'];
              setQueryAnalyser([...queryAnalyser, QueryAnalyser]);
            }
            if (item['Response Synthesizer Agent']) {
              item['Query Analyser'] = QueryAnalyser;
              setSessionContext([...sessionContext, item]);
              const finalResponse = item['Response Synthesizer Agent'];
              // TEMPORARILY DISABLING QUESTION SHUFFLING
              // const shuffledSuggestions = shuffleArray([...latestSuggestions]);
              const shuffledSuggestions = [...latestSuggestions]; // Keep original order
              saveChatHistory({
                question: question,
                answer: finalResponse,
                images: JSON.stringify(response?.images),
                agent_metadata: JSON.stringify(item['agent_metadata']),
                email: currentUserEmail,
                response_time_in_seconds: getSeconds(startTime, endTime),
                hash: response?.hash ? response?.hash : '',
                request_id: reqId,
              });
              lastChatHistory.push({
                request_id: reqId,
                chatId: reqId,
                sender: 415,
                chatMessage: finalResponse,
                images: response?.images,
                content: finalResponse,
                question: question,
                suggestions: shuffledSuggestions,
                is_liked: false,
                is_disliked: false,
                is_saved: false,
                response_time_in_seconds: getSeconds(startTime, endTime),
                agent_metadata: item['agent_metadata1'],
                isError: false,
                QueryAnalyser: QueryAnalyser,
                hash: response?.hash ? response?.hash : '',
              });
              responses.push({
                request_id: reqId,
                chatId: reqId,
                sender: 415,
                chatMessage: genereateGridRow(finalResponse),
                images:
                  Array.isArray(response?.images) && response?.images.length > 0
                    ? getImageBox(response?.images)
                    : [],
                content: finalResponse,
                question: question,
                suggestions: shuffledSuggestions,
                is_liked: false,
                is_disliked: false,
                is_saved: false,
                response_time_in_seconds: getSeconds(startTime, endTime),
                agent_metadata: item['agent_metadata'],
                isError: false,
                QueryAnalyser: QueryAnalyser,
                hash: response?.hash ? response?.hash : '',
              });
              localStorage.setItem(
                'lastChatHistory',
                JSON.stringify(lastChatHistory)
              );
              dispatch(updateSummary(JSON.stringify(lastChatHistory)));
              setMessages([...oldMessages, ...responses]);
              setIsIdeal(true);
            }
          });
        }
      })
      .catch(async (err) => {
        console.log('ERROR::::', err);
        const endTime = Date.now();
        if (axios.isCancel(err)) {
          console.log('REQUEST CANCELLED:', err.message);
        }
        if (err && err.response && err.response.data) {
          const response = err.response.data;
          saveChatHistory({
            question: question,
            answer: response?.error,
            email: currentUserEmail,
            images: JSON.stringify([]),
            agent_metadata: JSON.stringify([]),
            response_time_in_seconds: getSeconds(startTime, endTime),
            request_id: reqId,
          });
          lastChatHistory.push({
            request_id: reqId,
            chatId: reqId,
            sender: 415,
            chatMessage: response?.error,
            images: [],
            content: response?.error,
            question: question,
            suggestions: latestSuggestions,
            is_liked: false,
            is_disliked: false,
            is_saved: false,
            errorStatus: err.response.status,
            response_time_in_seconds: getSeconds(startTime, endTime),
            isError: true,
            hash: response?.hash ? response?.hash : '',
          });
          responses.push({
            request_id: reqId,
            chatId: reqId,
            sender: 415,
            chatMessage: response?.error,
            images: [],
            content: response?.error,
            question: question,
            suggestions: latestSuggestions,
            is_liked: false,
            is_disliked: false,
            is_saved: false,
            errorStatus: err.response.status,
            response_time_in_seconds: getSeconds(startTime, endTime),
            isError: true,
            hash: response?.hash ? response?.hash : '',
          });
        }
        localStorage.setItem(
          'lastChatHistory',
          JSON.stringify(lastChatHistory)
        );
        dispatch(updateSummary(JSON.stringify(lastChatHistory)));
        setMessages([...oldMessages, ...responses]);
        setIsIdeal(true);
      });
  };
  const clearAllRecentQueries = async () => {
    setLoading(true);
    const response = await deleteRecentQueries({
      email: currentUserEmail,
    });
    console.log('delete recent queries::', response);
    const result = await getChatHistory(currentUserEmail!);
    if (result && result.length > 0) {
      setChatHistory(result);
    } else {
      setChatHistory([]);
    }
    setLoading(false);
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_RECENT_SEARCHES_CLEAR_ALL_BUTTON',
      'clicked on CLEAR ALL button to c;ear the recent searches'
    );
  };
  const getImageBox = (data: string[]) => {
    return (
      <div className='wordwrap display-grid-template-columns'>
        {data &&
          data.length !== 0 &&
          data.map((img: any, imgIndex: number) => {
            return (
              <div key={imgIndex}>
                <img
                  src={`data:image/png;base64,${img}`}
                  className='chatImageSize'
                  // style={{height:"300px",width:"300px"}}
                  alt={
                    img.section_name
                      ? img.section_name
                      : 'reponse image' + imgIndex
                  }
                />
                <br />
              </div>
            );
          })}
      </div>
    );
  };

  const genereateGridRow = (dataContent: string) => {
    if (!dataContent) return <span>No data found</span>;
    const data = dataContent
      .replace('| sender: Response Synthesizer Agent', '')
      .replace(
        'sender: Text-to-SQL Agent" additional_kwargs={} response_metadata={}',
        ''
      )
      .replace(
        "sender: Text-to-SQL Agent' additional_kwargs={} response_metadata={}",
        ''
      )
      .replace(
        "sender: Analyst Agent' additional_kwargs={} response_metadata={}",
        ''
      )
      .replace('/\n\n(.*?)\n\n1/g', '\n$1')
      .replace(CONTENT_REGEX_TWO, '')
      .replace(CONTENT_REGEX, '');

    // return data?.includes("|")?<ChatRender rawText={data} />:data
    // return data?.includes("|")?<ChatRender rawText={data} />:data

    return data?.split('\n').map((item: any, idx: number) => {
      return (
        !item.includes('-----') && (
          <span key={idx}>
            {item.includes('###') ? (
              <>
                <br />
                <h4>{item.replace('###', '')}</h4>
              </>
            ) : item.includes('|') ? (
              <>
                <Row>
                  {item.split('|').map((rowItem: any, rowIdx: number) => {
                    return (
                      rowIdx !== 0 &&
                      item.split('|').length - 1 !== rowIdx && (
                        <>
                          <Col
                            style={{border: '1px solid black'}}
                            key={rowIdx}
                          >
                            {rowItem}
                          </Col>
                        </>
                      )
                    );
                  })}
                </Row>
              </>
            ) : (
              <>
                <span
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      '<span>' +
                        (item.includes('**')
                          ? item.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
                          : item) +
                        '</span>'
                    ),
                  }}
                />
                <br />
              </>
            )}
          </span>
        )
      );
    });
  };

  const handleSend = (message: any) => {
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_CHATBOX_SEND_BUTTON',
      'Clicked to send text to AI with text: ' + message
    );
    setIsIdeal(false);
    setMessages([...messages, {sender: 123, chatMessage: message, images: []}]);
    setIsMessageSent(true);
    setLoading(true);
    handlePlaceHolderMessage();
    getChatResp(message, [
      ...messages,
      {sender: 123, chatMessage: message, images: []},
    ]);
    setChatHistory([...chatHistory, message]);
  };

  const cancelRequest = () => {
    if (cancelTokenSource) {
      console.log('API KILLED');
      cancelTokenSource.cancel('Request was canceled by the user.');
    }
  };

  const handleResetToNewChat = () => {
    console.log('cancelled requestid', requestId);
    setLatestSuggestions(TOPLINE_AUTO_SUGGESTIONS_WHAT);
    cancelRequest();
    setMessages([]);
    setIsMessageSent(false);
    setIsIdeal(true);
    setThreadId1('');
    setThreadId2('');
    setSessionContext([]);
    setQueryAnalyser([]);
    setInputValue('');
    localStorage.setItem('lastChatHistory', '');
    dispatch(updateSummary(''));
    setShowDashboard(false);
    setAttachmentId('');
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_NEW_CHAT_BUTTON',
      'clicked on NEW CHAT button to initialize a new chat session'
    );
    setDisableSummaryBtn(false);
    localStorage.removeItem('DataSource');
  };
  const handleMessages = (updatedMessages: any) => {
    setMessages(updatedMessages);
    localStorage.setItem('lastChatHistory', JSON.stringify(updatedMessages));
    dispatch(updateSummary(JSON.stringify(updatedMessages)));
    setLoading(false);
  };

  const handleSummary = (projName: string) => {
    //  if (projName === 'UAE MT') {
    //         // Pass BOTH the destination AND the action
    //         onSourceSelect('uae_mt', 'getSummary');
    //         return;
    //     }
    // // else if (projName === 'SpendWise') {
    // // 		localStorage.setItem('DataSource', 'SpendWise');
    // // 	}
    // else {
    // 		localStorage.setItem('DataSource', 'topline');
    // 	}
    const resolvedDataSource = isMiddleEastMarket(projName)
      ? MIDDLE_EAST_DATA_SOURCE
      : projName;

    if (isMiddleEastMarket(projName)) {
      const selectedMarket = localStorage.getItem('SelectedMarket');
      if (!isMiddleEastMarket(selectedMarket)) {
        localStorage.setItem('SelectedMarket', projName);
      }
    }

    localStorage.setItem("DataSource", resolvedDataSource);
    setPageTitle(projName);
    projName && dispatch(updateTitle(projName));
    let currDate = new Date();

    // setPageTitle(projName);
    // projName && dispatch(updateTitle(projName));
    // let currDate = new Date();
    let filters = {
      year: currDate.getFullYear(),
      month: currDate.getMonth() - 1,
      region: '',
      retailer: '',
      subCategory: '',
      productUniverse: '',
      manufacturer: '',
      brand: '',
      comparison: 'YTD',
      insightsType: '',
      kpi: '',
    };

    let req: summaryProps = {
      projName: projName,
      time_dimension: 'L1W',
      ...(isMiddleEastMarket(projName) && { filters: filters }),
    };
    if (projName === 'UAE MT') {
      onSourceSelect('uae_mt', 'getSummary');
      return;
    }
    getSummary(req);
  };

  const handleSummary2 = (payload: any) => {
    getSummary(payload);
  };

  const handleDashboardClick = (projName: string, url: string) => {
    setPageTitle(projName);
    setDashboardURL(url);
    setShowDashboard(true);
  };
  // const showRecentQueries = () => {
  //   togglePanel();
  // };
  // Function to toggle the panel
  useEffect(() => {
    // This function will run whenever the panel is opened
    const fetchChatHistory = async () => {
      setLoading(true);
      const result = await getChatHistory(currentUserEmail!);
      if (result && result?.length > 0) {
        setChatHistory(result);
      } //added else statement to fix the undefined legth issue
      else {
        setChatHistory([]);
      }
      setLoading(false);
    };

    // We only fetch data when the panel's prop is true
    if (isPanelOpen) {
      fetchChatHistory();
    }
  }, [isPanelOpen]);
  const getRecentQueryDetails = (selectedHistory: any) => {
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_RECENT_QUERIES_QUESTION',
      'clicked on one of the query from recent queries: ' +
        selectedHistory.question
    );

    selectedHistory['agent_metadata'] = JSON.parse(
      selectedHistory['agent_metadata']
    );
    selectedHistory['images'] = JSON.parse(selectedHistory['images']);

    const formattedObjResponse = [
      {sender: 123, chatMessage: selectedHistory.question, images: []},
      {
        chatId: selectedHistory.id!,
        sender: 415,
        chatMessage: genereateGridRow(selectedHistory.answer),
        images:
          Array.isArray(selectedHistory.images) &&
          selectedHistory.images.length > 0
            ? getImageBox(selectedHistory.images)
            : [],
        content: selectedHistory.answer,
        question: selectedHistory.question,
        suggestions: latestSuggestions,
        is_liked: selectedHistory.is_liked,
        is_disliked: selectedHistory.is_disliked,
        is_saved: selectedHistory.is_saved,
        response_time_in_seconds: selectedHistory.response_time_in_seconds,
        agent_metadata: selectedHistory['agent_metadata'],
        isError: false,
      },
    ];
    const finalResponse = [...messages, ...formattedObjResponse];
    setMessages(finalResponse);
    localStorage.setItem('lastChatHistory', JSON.stringify(finalResponse));
    dispatch(updateSummary(JSON.stringify(finalResponse)));
  };
  return (
    <div>
      <TabTitle
        title={''}
        handleClick={handleResetToNewChat}
        chatTitle={'New Chat'}
        isBackBtn={showDashboard}
        handleBack={() => setShowDashboard(false)}
        isRecentQueries={true}
        handleRecentQueries={togglePanel}
        messages={messages}
      />
      {showDashboard ? 'showDashboard' : 'NO Dashboard'}
      {!showDashboard ? (
        <div className={styles.mainDiv}>
          {messages?.length === 0 && (
            <DashboardListInChat
              handleViewSummary={handleSummary}
              handleDashboard={handleDashboardClick}
              onPage='NEW_DAILOG'
              loading={disableSummaryBtn}
              loadingTitle={pageTitle}
            />
          )}
          {/* code for sidePanel */}
          <div className={`right-panel ${isPanelOpen ? 'open' : ''}`}>
            {isLoading ? (
              <div className={'loaderWrapperRightPanel'}>
                <Spinner
                  animation='border'
                  variant='primary'
                >
                  <span className='visually-hidden'></span>
                </Spinner>
              </div>
            ) : (
              <div className='mt20Percent p20'>
                <span
                  onClick={togglePanel}
                  className='cursor-pointer flex-align-items-center-space-between'
                >
                  <h3>Recent Queries </h3> <CloseIcon />
                </span>
                {chatHistory && chatHistory.length > 0 ? (
                  chatHistory?.map((element: any) => {
                    return (
                      <p
                        className={styles.query}
                        onClick={() => getRecentQueryDetails(element)}
                      >
                        {element.question}
                      </p>
                    );
                  })
                ) : (
                  <p className={styles.emptyQueries}>No Recent queries</p>
                )}
                {chatHistory && chatHistory.length > 0 && (
                  <Button
                    className={styles.clearAll}
                    onClick={clearAllRecentQueries}
                  >
                    Clear All
                  </Button>
                )}
              </div>
            )}
          </div>
          <div>
            {messages?.length > 0 && (
              <div className={styles.messages}>
                <MessageList
                  messages={messages}
                  isIdeal={isIdeal}
                  setInputValue={setInputValue}
                  setSuggestions={setLatestSuggestions}
                  onSend={handleSend}
                  handleChange={(data: any) => handleMessages(data)}
                  title={pageTitle}
                  disableSummaryBtn={disableSummaryBtn}
                  handleSummary2={handleSummary2}
                />
                {loadingMessage !== '' && (
                  <div className={styles.loadingContainer}>
                    <div className={styles.loadingMessage}>
                      {displayMessage}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className={
              isMessageSent ? styles.chatbotBottom : styles.chatbotMiddle
            }
          >
            {messages?.length > 0 && (
              <InputField
                onSend={handleSend}
                onEnter={handleSend}
                isMessageSent={isMessageSent}
                resetToNewChat={handleResetToNewChat}
                isIdeal={isIdeal}
                dataSource={currentDataSource}
                inputValue={inputValue}
                setInputValue={setInputValue}
                hidden={!restrictedUsers.includes(currentUserEmail!)}
                handleDocId={(docId: string) => setAttachmentId(docId)}
                pageTitle={pageTitle}
              />
            )}
          </div>
        </div>
      ) : (
        <PBIDashboard
          title={pageTitle}
          dashboardURL={dashboardURL}
          onPage={'NEW_DIALOG'}
        />
      )}
    </div>
  );
};

export default Layout(ChatBotComponent);
